import { IAPIIntermediateResponse } from "../../ts/api";

export function intermediateResponseFormatter(response: IAPIIntermediateResponse): Promise<string> {
    return Promise.resolve(response.s3_public_url);
}